import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSoundEmissionLrMaxLimit,
  setSoundEmissionLrMax,
  setSoundEmissionReceiverLinksVisible,
} from "../redux/soundEmission";
import { Switch } from "./Switch";
import "./InformationBox/SoundEmissionInfoBox.css";

const MIN_LR_MAX = 0;

const SoundEmissionLrMaxSlider = () => {
  const dispatch = useDispatch();
  const { isVisible, lrMax, apiLrMax, receiverLinksVisible } = useSelector(
    (state) => state.soundEmission,
  );
  const [inputValue, setInputValue] = useState(String(lrMax));
  const maxLrMax = getSoundEmissionLrMaxLimit(apiLrMax);

  useEffect(() => {
    setInputValue(String(lrMax));
  }, [lrMax]);

  if (!isVisible) return null;

  const hasLrMax = Number.isFinite(lrMax) && Number.isFinite(apiLrMax);

  const percentage = hasLrMax
    ? ((lrMax - MIN_LR_MAX) / (maxLrMax - MIN_LR_MAX)) * 100
    : 0;

  const commitInputValue = () => {
    if (inputValue.trim() === "") {
      setInputValue(String(lrMax));
      return;
    }
    const numericValue = Number(inputValue);
    if (!Number.isFinite(numericValue)) {
      setInputValue(String(lrMax));
      return;
    }
    dispatch(setSoundEmissionLrMax(numericValue));
  };

  return (
    <div className="sound-emission-slider-control">
      <div className="sound-emission-slider">
        <div className="sound-emission-slider__toggles">
          <Switch
            checked={receiverLinksVisible}
            onChange={(checked) =>
              dispatch(setSoundEmissionReceiverLinksVisible(checked))
            }
            label="Receiver links"
            title={
              receiverLinksVisible
                ? "Hide candidate-to-receiver links"
                : "Show candidate-to-receiver links"
            }
          />
        </div>
        {hasLrMax && (
          <>
            <div className="sound-emission-slider__header">
              <span>
                <strong>Lr max at receivers</strong>
              </span>
              <label className="sound-emission-slider__input">
                <input
                  type="number"
                  min={MIN_LR_MAX}
                  max={maxLrMax}
                  step="0.1"
                  value={inputValue}
                  onChange={(event) => setInputValue(event.target.value)}
                  onBlur={commitInputValue}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      commitInputValue();
                      event.currentTarget.blur();
                    }
                  }}
                />
                <span>dB(A)</span>
              </label>
            </div>
            <input
              type="range"
              min={MIN_LR_MAX}
              max={maxLrMax}
              step="0.1"
              value={lrMax}
              aria-label="Maximum sound level at receivers"
              onChange={(event) =>
                dispatch(setSoundEmissionLrMax(Number(event.target.value)))
              }
              style={{
                background: `linear-gradient(to right, var(--clr-primary) 0%, var(--clr-primary) ${percentage}%, #dfe4ea ${percentage}%, #dfe4ea 100%)`,
              }}
            />
            <div className="sound-emission-slider__limits">
              <span>{MIN_LR_MAX}</span>
              <span>{maxLrMax} dB(A)</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SoundEmissionLrMaxSlider;
